<template>
    <nav
        class="progress-bar"
        :class="{
            'progress-bar--no-customize': $store.getters.isCuratedLink
        }"
    >
        <div class="progress-bar__in-between"></div>
        <ul class="list-none flex w-full justify-between">
            <li
                class="progress-bar__step"
                :class="{
                    'progress-bar__step--active': currentStep >= 0 || orderComplete,
                }"
                v-if="!$store.getters.isCuratedLink"
                data-qa="current-step-0"
            >
                <button class="progress-bar__label" @mousedown="goToStep(0)" data-qa="progress-customize-button">Customize</button>
            </li>
            <li
                class="progress-bar__step"
                :class="{
                    'progress-bar__step--active': currentStep >= 1 || orderComplete,
                }"
                data-qa="current-step-1"
            >
                <button class="progress-bar__label" @mousedown="goToStep(1)" data-qa="progress-payment-button">Payment</button>
            </li>
            <li
                class="progress-bar__step"
                :class="{
                    'progress-bar__step--active': orderComplete,
                }"
                data-qa="current-step-2"
            >
                <span class="progress-bar__label">Confirm</span>
            </li>
        </ul>
    </nav>
</template>

<script>

export default {
    data() {
        return {
            oldCurrentStep: 0,
        }
    },
    methods: {
        goToStep(step) {
            if (!this.orderComplete && !this.showContactSales) {
                this.currentStep = step;
                this.oldCurrentStep = step;
            }
        }
    },
    computed: {
        orderComplete() {
            return this.$store.getters.orderComplete;
        },
        showContactSales() {
            return this.$store.getters.showContactSales;
        },
        currentStep: {
            get() {
                return this.$store.getters.currentStep;
            },
            set( step ) {
                this.$store.commit('setCurrentStep', step);
            }
        }
    },
    watch: {
        showContactSales(newVal, oldVal) {
            if (newVal) {
                this.oldCurrentStep = this.currentStep;
                this.currentStep = 0;
            } else {
                this.currentStep = this.oldCurrentStep;
            }
        }
    }
};
</script>

<style lang="postcss" scoped>
    .progress-bar {
        @apply flex justify-between max-w-[212px] md:max-w-[348px] w-3/4 relative mx-auto;

        &--no-customize {
            @apply max-w-[182px]
        }

        &__step {
            @apply w-4 h-4 rounded-full bg-gray-3 flex justify-center z-20 transition-colors delay-200;

            &--active {
                @apply bg-green-default;
            }
        }

        &__in-between {
            @apply absolute w-full h-[2px] bg-gray-3 top-[7px] z-10;
        }

        &__label {
            @apply absolute text-xs;
            top: calc(100% + 20px);
        }
    }
</style>
